import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import "./styles/current.css";
import "./styles/chat.css" 
import "./styles/billStyle.css" 
import 'react-circular-progressbar/dist/styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-toastify/dist/ReactToastify.css";

import { install } from "resize-observer";

if (typeof window !== "undefined") {
  install();
}

install();

ReactDOM.render(<App />, document.querySelector("#root"));
